import { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";
const ThemeContext = createContext();
export const useTheme = () => useContext(ThemeContext);
import getIP from "../getIP.js";
const IP = getIP();
import { useQuery } from "react-query";
import { getGlobalConfigNoAuth } from "../lib/login-api.js";

export const ThemeProvider = ({ children }) => {
  const { data: configData, isLoading: isAuthConfigLoading } = useQuery(
    ["noAuthConfig"],
    getGlobalConfigNoAuth,
    {
      onError: (err) => {
        console.log("error while getting config no auth: ", err);
      },
    }
  );
  const [theme, setTheme] = useState({
    font: "Nunito",
    logos: `${IP}/static/media/comviva-logo.45738fc35a5d95d312d062c1f0ff94cf.svg`,
    loginLogo: `${IP}/static/media/comviva-logo.45738fc35a5d95d312d062c1f0ff94cf.svg`,
    enableLoginLogo: "Enable",
    primaryColor: "#E00800",
    secondaryColor: "#353ef2",
    tertiaryColor: "#777578",
    sideMenuColor: "#2d2e42",
    backgroundColor: "#f5f5fa",
    tncUrl: ``,
    policyUrl: ``,
    backgroundImageLandingPage: `${IP}/static/media/comviva-background.18edf10ea57d4ea52fba.jpg`,
    announcementText: "Hello, Brand Setting page is being defined.........",
    announcementUrl: IP,
    announcementFlag: "Enable",
    faviconUrl: "https://ngagecpaas.com/favicon.ico",
    menuTextColor: "#FFFFFF",
    menuTextColorOnHover: "#ED1C24",
    radioCheckboxColor: "#353ef2",
    enablePolicy: "Disable",
    enableTerms: "Disable",
    selectedLanguages: [
      {
        title: "English",
        code: "en",
      },
    ],
    enableSignUp: "Enable",
    footer: "All rights reserved.",
    display: "",
    dateFormat: "dd/MM/yyyy",
    timeFormat: "HH:mm:ss",
    url: "",
    borderRadius: "0.375rem", // md
    // primaryColor: "#4B0F1E",
    // secondaryColor: "#E00800",
    // fontFamily: "SuisseIntl",
    // tertiaryColor: "#232323",
    // sideMenuColor: "#4B0F1E",
    // backgroundColor: "white",

    // Add more theme properties as needed
  });
  // useEffect(()=>{
  //   sessionStorage.setItem('theme', JSON.stringify(theme));
  // },[])

  const { refetch } = useQuery(["getBrandList"], fetchColorsFromApi, {
    enabled: !isAuthConfigLoading,
    onSuccess: (data) => {
      if (data) {
        let defaultSettings = {
          font: "Nunito",
          logos: `${IP}/static/media/comviva-logo.45738fc35a5d95d312d062c1f0ff94cf.svg`,
          loginLogo: `${IP}/static/media/comviva-logo.45738fc35a5d95d312d062c1f0ff94cf.svg`,
          enableLoginLogo: "Enable",
          primaryColor: "#E00800",
          secondaryColor: "#353ef2",
          tertiaryColor: "#777578",
          sideMenuColor: "#2d2e42",
          backgroundColor: "#f5f5fa",
          radioCheckboxColor: "#353ef2",
          tncUrl: ``,
          policyUrl: ``,
          backgroundImageLandingPage: `${IP}/static/media/comviva-background.18edf10ea57d4ea52fba.jpg`,
          announcementText:
            "Hello, Brand Setting page is being defined.........",
          announcementUrl: IP,
          announcementFlag: "Enable",
          faviconUrl: "https://ngagecpaas.com/favicon.ico",
          menuTextColor: "#FFFFFF",
          menuTextColorOnHover: "#ED1C24",
          enablePolicy: "Disable",
          enableTerms: "Disable",
          selectedLanguages: [
            {
              title: "English",
              code: "en",
            },
          ],
          enableSignUp: "Enable",
          footer: "All rights reserved.",
          enableLabel: "false",
          labelName: "CPaaS",
          display: "",
          url: "",
          dateFormat: "MM-DD-YYYY",
          timeFormat: "HH:mm:ss",
          borderRadius: "0.375rem", // md
        };

        let color = typeof data?.data?.[0]?.brandSettingJson==='object' && Object.keys(data?.data?.[0]?.brandSettingJson).length > 0 ? data?.data?.[0]?.brandSettingJson : defaultSettings;
        document.body.style.backgroundColor = color.backgroundColor;
        try {
        let urlObj = new URL(color.logos);
        color.logos = new URL(
          urlObj.pathname + urlObj.search + urlObj.hash,
          IP
        ).toString();

        urlObj = new URL(color.backgroundImageLandingPage);
        urlObj = new URL(urlObj.pathname + urlObj.search + urlObj.hash, IP);
        color.backgroundImageLandingPage = urlObj.toString();

        urlObj = new URL(color.faviconUrl);
        urlObj = new URL(urlObj.pathname + urlObj.search + urlObj.hash, IP);
        color.faviconUrl = urlObj.toString();
      } catch(err) {
        console.log("Error parsing URLs: ", err);
      }

        let bflag =
          configData?.find((e) => e.key === "bflag")?.value || "false";
        let defaultStyle =
          configData?.find((e) => e.key === "defaultStyleFlag")?.value ||
          "true";
        console.log("[INFO] defaultStyle enabled: ", defaultStyle);
        let enableBackgroundLogo =
          configData?.find((e) => e.key === "enableBackgroundLogo")?.value ||
          "true";
        let flags = {};
        flags.bflag = bflag;
        flags.defaultStyle = defaultStyle;
        flags.enableBackgroundLogo = enableBackgroundLogo;

        const linkElement =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        linkElement.type = "image/png";
        linkElement.rel = "icon";
        linkElement.href = color.faviconUrl;
        document.title =
          color.enableLabel === "true" ? color.labelName : "CPaaS";
        document.head.appendChild(linkElement);
        const themeValue = { ...defaultSettings, ...color, ...flags };
        setTheme(themeValue);

        document.documentElement.style.setProperty(
          "--primaryColor",
          themeValue.primaryColor
        );
        document.documentElement.style.setProperty(
          "--secondaryColor",
          themeValue.secondaryColor
        );
        document.documentElement.style.setProperty(
          "--tertiaryColor",
          themeValue.tertiaryColor
        );
        document.documentElement.style.setProperty(
          "--backgroundColor",
          themeValue.backgroundColor
        );

        if (themeValue.font === "Nunito") {
          document.documentElement.style.setProperty(
            "--table-content-font-weight",
            600
          );
          document.documentElement.style.setProperty(
            "--button-font-weight",
            700
          );
        }

        sessionStorage.setItem("theme", JSON.stringify(themeValue));
        setIsThemeLoading(false);
      } else {
        let res = sessionStorage.getItem("theme");
        if (!res) {
          sessionStorage.setItem("theme", JSON.stringify(theme));
        } else {
          setTheme(JSON.parse(res));
        }
        setIsThemeLoading(false);
      }
    },
    onError: () => {
      let res = sessionStorage.getItem("theme");
      if (!res) {
        sessionStorage.setItem("theme", JSON.stringify(theme));
      } else {
        setTheme(JSON.parse(res));
      }

      setIsThemeLoading(false);
    },
  });

  const [isThemeLoading, setIsThemeLoading] = useState(true);

  return (
    <ThemeContext.Provider
      value={{
        theme,
        setTheme,
        isThemeLoading,
        isAuthConfigLoading,
        refetch,
        formatDatePickerDate: (dateFormatStr, timeFormatStr) => {
          try {
            const formattedDate = dateFormatStr
              ?.replace(/D/g, "d")
              ?.replace(/Y/g, "y");
            console.log(
              `[INFO] received format ${dateFormatStr} ${timeFormatStr}\nFormatted date: ${formattedDate} ${timeFormatStr}`
            );
            return formattedDate + (timeFormatStr ? " " + timeFormatStr : "");
          } catch (error) {
            console.error("Error parsing date format string:", error);
            return dateFormatStr; // or handle the error as needed
          }
        },
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
async function fetchColorsFromApi() {
  const IP = getIP();
  const response = await axios(`${IP}` + "/api/v1/config/brand");

  return response?.data;

  // Assuming the API returns an object with color values
}
